module.exports = __webpack_public_path__ + "img/hospital.55740098.svg";